module.exports = __webpack_public_path__ + "assets/img/slogan-6195186b.png";